import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
import { useContext } from 'react';
import classnames from 'classnames';
import { Icon } from "../../Icon/Icon/Icon";
import { Link } from "../../Button/Link/Link";
import Utility from "../../Utility/Utility";
import { ThemeContext } from "../../../context/theme.context";
import styles from "./Pagination.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var defaultPropsPagination = {
  pageUrl: '',
  activePage: 0,
  totalPages: 0,
  labels: {
    prevLabel: 'Previous',
    nextLabel: 'Next',
    prevTitle: 'Go to previous page',
    nextTitle: 'Go to next page',
    itemTitle: 'Go to page !page'
  }
};
export var Pagination = function Pagination(_ref) {
  var _ref$pageUrl = _ref.pageUrl,
    pageUrl = _ref$pageUrl === void 0 ? defaultPropsPagination.pageUrl : _ref$pageUrl,
    _ref$activePage = _ref.activePage,
    activePage = _ref$activePage === void 0 ? defaultPropsPagination.activePage : _ref$activePage,
    _ref$totalPages = _ref.totalPages,
    totalPages = _ref$totalPages === void 0 ? defaultPropsPagination.totalPages : _ref$totalPages,
    _ref$labels = _ref.labels,
    labels = _ref$labels === void 0 ? _objectSpread({}, defaultPropsPagination.labels) : _ref$labels;
  var theme = useContext(ThemeContext);
  var buildPages = function buildPages() {
    // Pager displays 5 items:  active and the 2 previous/next.
    var startPage = Math.max(1, Math.min(activePage - 2, totalPages - 4));
    var endPage = Math.min(totalPages, startPage + 4);
    var showPrev = activePage > 1;
    var showPrevEllipsis = totalPages > 5 && activePage > 3;
    var showNext = activePage < totalPages;
    var showNextEllipsis = totalPages > 5 && activePage < totalPages - 2;
    var url;
    try {
      url = new URL(pageUrl);
      url.searchParams.delete('page');
    } catch (e) {
      console.error('Pagination pageUrl needs to be absolute.');
      return null;
    }
    var pages = [];
    var i = startPage;
    while (i <= endPage) {
      url.searchParams.set('page', String(i - 1));
      var itemTitle = Utility.parseInterpolationParams(labels.itemTitle ? labels.itemTitle : '', {
        page: "".concat(i)
      });
      pages.push(i === activePage ? /*#__PURE__*/_jsx("li", {
        className: styles.paginationActive,
        children: /*#__PURE__*/_jsx("span", {
          children: i
        })
      }, i) : /*#__PURE__*/_jsx("li", {
        className: styles.paginationItem,
        children: /*#__PURE__*/_jsx(Link, {
          url: url.toString(),
          preserveUrlQuery: true,
          excludeFromUrlQuery: ['page'],
          accessibilityLabel: itemTitle,
          children: i
        })
      }, i));
      i += 1;
    }
    if (showPrevEllipsis) {
      pages.unshift( /*#__PURE__*/_jsx("li", {
        className: styles.paginationEllipsis,
        children: "..."
      }, "prev-ellipsis"));
    }
    if (showPrev) {
      url.searchParams.set('page', String(activePage - 2));
      pages.unshift( /*#__PURE__*/_jsx("li", {
        className: styles.paginationPrev,
        children: /*#__PURE__*/_jsxs(Link, {
          url: url.toString(),
          preserveUrlQuery: true,
          excludeFromUrlQuery: ['page'],
          accessibilityLabel: labels.prevTitle,
          children: [/*#__PURE__*/_jsx(Icon, {
            className: styles.paginationArrowIcon,
            type: "arrow-left",
            width: "20px",
            height: "20px",
            noFill: true
          }), /*#__PURE__*/_jsx(Icon, {
            className: styles.paginationPrimaryLinkIcon,
            type: "primary-link",
            width: "28px",
            height: "28px",
            noFill: true
          }), /*#__PURE__*/_jsx("span", {
            className: styles.paginationPrevText,
            children: labels.prevLabel
          })]
        })
      }, "prev"));
    }
    if (showNextEllipsis) {
      pages.push( /*#__PURE__*/_jsx("li", {
        className: styles.paginationEllipsis,
        children: "..."
      }, "next-ellipsis"));
    }
    if (showNext) {
      url.searchParams.set('page', String(activePage));
      pages.push( /*#__PURE__*/_jsx("li", {
        className: styles.paginationNext,
        children: /*#__PURE__*/_jsxs(Link, {
          url: url.toString(),
          preserveUrlQuery: true,
          excludeFromUrlQuery: ['page'],
          accessibilityLabel: labels.nextTitle,
          children: [/*#__PURE__*/_jsx(Icon, {
            className: styles.paginationArrowIcon,
            type: "arrow-right",
            width: "20px",
            height: "20px",
            noFill: true
          }), /*#__PURE__*/_jsx("span", {
            className: styles.paginationNextText,
            children: labels.nextLabel
          }), /*#__PURE__*/_jsx(Icon, {
            className: styles.paginationPrimaryLinkIcon,
            type: "primary-link",
            width: "28px",
            height: "28px",
            noFill: true
          })]
        })
      }, "next"));
    }
    return pages;
  };
  if (!pageUrl) {
    return null;
  }
  return /*#__PURE__*/_jsx("ul", {
    className: classnames(styles.paginationList, theme === 'darkBackground' ? styles.paginationListDarkBackground : null),
    children: buildPages()
  });
};